enum FooterDocument {
  CGU = 'ECE - CGU - SUEZ RV - V2.pdf',
  PRIVATE_POLICY = 'ECE - Politique de confidentialité - SUEZ RV - V2.pdf',
  LEGAL_NOTICES = 'ECE - Mentions légales - SUEZ RV - V2.pdf',
  COOKIES_CHARTE = 'ECE - Charte de gestion des cookies - V4.pdf',
  CGV = 'terms-of-sales_FR.pdf',
}

export default FooterDocument
